customElements.define(
  "recently-sold",
  class extends HTMLElement {
    constructor() {
      super();

      this.injectNumber();
    }

    // Function to get a cookie by name
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(";").shift();
      return null;
    }

    //  to set a cookie
    setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = `expires=${date.toUTCString()}`;
      document.cookie = `${name}=${value}; ${expires}; path=/`;
    }

    //  to generate a random number and store it in a cookie
    generateNumber() {
      const number = Math.floor(Math.random() * 100) + 1; // Random number between 1 and 100
      return number;
    }

    //  to inject a unique number for each page
    injectNumber() {
      const pageIdentifier = window.location.pathname; // Use the URL path as a unique page identifier
      const cookieName = `pageNumber_${pageIdentifier}`; // Create a unique cookie name for each page
      const pageNumber = this.getCookie(cookieName);

      if (pageNumber) {
        // numberElement.textContent = pageNumber; // Use the existing cookie value
        this.innerHTML = this.innerHTML.replace("[number]", pageNumber);
      } else {
        const newNumber = this.generateNumber(); // Generate a new number if no cookie is found
        this.setCookie(cookieName, newNumber, 1); // Store the number in a cookie for 1 day
        // numberElement.textContent = newNumber;

        this.innerHTML = this.innerHTML.replace("[number]", newNumber);
      }
    }
  }
);
